import { render, staticRenderFns } from "./PrivateTypeIndex.vue?vue&type=template&id=76c756b0&"
import script from "./PrivateTypeIndex.vue?vue&type=script&lang=js&"
export * from "./PrivateTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports